import React from 'react'
import * as classes from './style.module.scss'

const baseUrl = process.env.GATSBY_BASE_URL;

export default function CapitalAndSponsors() {
    return <div className={classes.wrapper}>
        <div className={classes.content}>
            <header className={classes.header}>
                DIBS connects private companies with capital markets
            </header>
            <p>
                DIBS Capital is the leader in compliant tokenization of real world assets. Our predecessor, SolidBlock, which went on to form DIBS with Viant Capital’s CEO Scott Smith,
                pioneered the tokenization space: it was first to enable issuance and transfer of digital securities via minting tokens for commercial properties, which are trading now on tZero.
            </p>
            <p>
                DIBS built a large ecosystem of property owners, asset managers, digital investment banks,  technology and compliance providers and more.
            </p>
            <p>
                DIBS solves the biggest problem of private businesses: asset liquidity risk via distributed investment banking provides the following benefits:
                <ul>
                    <li>improved ability to convert assets to cash</li>
                    <li>new leverage opportunities</li>
                    <li>trading well-performing digital assets via publicly-traded structured products</li>
                    <li>liquidity management tools, e.g. cashflow balance prediction and portfolio optimization, including debt/equity</li>
                </ul>
            </p>
            <p>
                <b>DIBS differentiation:</b><br />
                DIBS Capital is the only brokerage company focused on solving private securities distribution challenges via providing a securities affiliate distribution platform utilizing a network of investment
                bankers and harnessing its potential with DLT and AI-based tools. 
            </p>
            <p>
                DIBS is the only solution positioned to take securities to the next level by looking at private securities as a cornerstone for the trading industry and a base
                for structured products, exchange-traded products like indexes and ETFs, and not as a stand-alone financial asset that private or institutional investors will
                start regularly trading just because they can.
            </p>
            <p>
                Just like TradFi ecosystem uses securities as a base for more complex products, so does DIBS within the web3/DeFi ecosystem, which is, again, unique to DIBS.
            </p>
            <p>
                Our ecosystem includes issuers, investment banks, lenders, structuring companies, benchmarking companies, listing companies, other syndicators and distributors will issue investment contracts.             </p>
            <p>
                DIBS enables and records transactions via web3, including sale, distribution, broker intros, OTC, collateralization of tokens, issuance of loans, aggregation of tokens into indices and structured products, and more.            </p>
            <p>
                DIBS is one of a small number of companies in the fintech space that combines co-founders who are seasoned investment bankers who managed and structured hundreds of billions of
                dollars-worth of products with the blockchain industry's early evangelists and visionaries with a rare combination of finance and tech background.  And we are 100% focused on
                digital securities and providing the platform to enable the most efficient distribution and thus, true liquidity and efficiency for the whole private securities-enabled financial
                ecosystem.
            </p>
            <p>
                <b>How liquidity is created</b><br />
                <ul>
                    <li>Assets are placed under custody by DIBS’ qualified partners (e.g. servicing companies)
                    </li>
                    <li>Digital units (security tokens) are minted by DIBS and are backed by those assets
                    </li>
                    <li>When asset owners need liquidity, they exchange parts of their assets for cash by selling these tokens to investors (along with economic interests, such as dividends)
                    </li>
                    <li>Tokens are traded via participating brokers & their affiliates
                    </li>
                    <li>Tokens can be leveraged on digital lending platforms
                    </li>
                    <li>Tokens can be combined into structured products (indexes and ETFs buying high-performing tokens), listed on institutional and public exchanges for trading and liquidity
                    </li>
                </ul>
            </p>
            <p>
                <b>Regulation:</b><br />
                <ul>
                    <li>Security tokens are considered legal and compliant privately-issued securities by the SEC, which recognizes wallet-to-wallet secondary market transfers when done via an ATS with a special purpose digital assets license
                        We use a compliant ATS to facilitate all secondary market transactions
                    </li>
                    <li>Any FINRA registered broker or equivalent outside of the US can facilitate securities sale as affiliate of Viant or our ATS partner
                    </li>
                </ul>
            </p>
            <p>
                <b>Technology</b><br />
                <ul>
                    <li>In order to enable private assets to be traded and leveraged without being listed on a public exchange, DIBS and its ecosystem partners use blockchain technology, which provides a secure infrastructure for disintermediated transfer of payments, assets and information.
                    </li>
                    <li>DIBS developed minting and monetization processes for asset owners which are fully compliant with regulatory requirements by design.
                    </li>
                </ul>
            </p>
        </div>
    </div>
}